import { DownArrowRedIcon, UpArrowGreenIcon } from 'assests/GmsIcons';
import React from 'react';
import { formatMetricValue } from '../AnalyticsHelper';
import { NONE } from '../AnalyticsConstants';

type MetricComponentProps = {
  metricValue: number;
  percentage: number;
  compareTo: string;
  metricName: string;
}

const MetricComponent = ({ metricValue, percentage, compareTo, metricName } : MetricComponentProps) => {

  return (
    <div className={`tw-flex tw-items-center tw-mt-2 tw-gap-3`}>
      <label className={`tw-text-[#091E42] tw-text-base tw-font-semibold`}>
        {formatMetricValue(metricName, metricValue)}
      </label>
      {compareTo !== NONE ? (
        <div
          className={`tw-rounded-sm ${
            percentage < 0 ? "tw-bg-whitesmoke-100" : "tw-bg-[#eff7f3]"
          }  tw-flex tw-flex-row tw-py-0.5 tw-px-1 tw-items-center tw-justify-center tw-gap-[2px] tw-text-xs ${
            percentage > 0 ? "tw-text-seagreen" : "tw-text-bearred"
          }tw-text-seagreen`}
        >
          {isFinite(percentage)  ? (
            percentage === 0 ? null : percentage < 0 ? (
              <DownArrowRedIcon />
            ) : (
              <UpArrowGreenIcon />
            )
          ) : null}
          <label
            className={`tw-font-medium ${
              percentage < 0 ? "tw-text-bearred" : "tw-text-seagreen"
            }`}
          >
            {isNaN(percentage) ? 0 : isFinite(percentage) ? percentage : 0}
          </label>
        </div>
      ) : null}
    </div>
  );
};

export default MetricComponent;
